import { Fragment, useState } from "react";
import { History } from "lucide-react";
import { usePoll } from "@/lib/usePoll";
import { num, usd, signed, dt } from "@/lib/api";
import { Panel, Badge, Empty, PageTitle } from "@/components/common";

export default function Trades() {
  const { data } = usePoll("/trades", 15000);
  const [open, setOpen] = useState(null);
  const rows = data || [];
  return (
    <div>
      <PageTitle title="Trade History" sub="Every real executed trade on Kraken, with fees, funding, net P/L, reserve allocation and the AI reasoning behind it. No simulated trades appear here." />
      <Panel title="Executed trades" icon={History} testid="trades-table">
        {rows.length === 0 ? <Empty testid="trades-empty">No trades executed yet. The system only trades when every gate passes.</Empty> : (
          <div className="overflow-x-auto">
            <table className="w-full font-mono text-xs">
              <thead><tr className="text-zinc-500 text-[10px] uppercase tracking-wider text-left border-b border-zinc-800">
                {["Trade ID", "Opened", "Side", "Entry", "Exit", "Size", "Lev", "Fees", "Funding", "Net P/L", "Reserve", "Exit reason"].map((h) => <th key={h} className="py-2 pr-3 whitespace-nowrap">{h}</th>)}</tr></thead>
              <tbody>
                {rows.map((t) => (
                  <Fragment key={t.id}>
                    <tr data-testid={`trade-row-${t.id}`} onClick={() => setOpen(open === t.id ? null : t.id)} className="border-b border-zinc-800/50 hover:bg-zinc-800/20 cursor-pointer">
                      <td className="py-2 pr-3 text-zinc-500">{t.id.slice(0, 8)}</td>
                      <td className="pr-3 text-zinc-400 whitespace-nowrap">{dt(t.opened_at || t.created_at)}</td>
                      <td className="pr-3"><Badge v={t.side === "long" ? "BUY" : "SHORT"}>{t.side === "long" ? "BUY" : "SHORT"}</Badge></td>
                      <td className="pr-3">{num(t.entry_price, 1)}</td><td className="pr-3">{num(t.exit_price, 1)}</td>
                      <td className="pr-3">{t.volume ?? "—"}</td><td className="pr-3">{num(t.leverage, 2)}x</td>
                      <td className="pr-3">{usd(t.fees, 4)}</td><td className="pr-3">{usd(t.funding, 4)}</td>
                      <td className={`pr-3 font-semibold ${t.net_pnl >= 0 ? "text-emerald-400" : "text-red-400"}`}>{signed(t.net_pnl, 4)}</td>
                      <td className="pr-3 text-blue-400">{usd(t.reserve_allocation, 4)}</td>
                      <td className="text-zinc-400">{t.exit_reason || t.status}</td>
                    </tr>
                    {open === t.id && (
                      <tr className="bg-[#0D0E15]"><td colSpan={12} className="p-4 text-zinc-400 font-sans text-sm">
                        <div className="font-mono text-[10px] text-zinc-500 mb-1">AI REASONING · {t.product} · fee source {t.fee_source || "—"}</div>
                        {t.reasoning || "—"}
                        {t.error && <div className="text-red-400 mt-2 font-mono text-xs">{t.error}</div>}
                      </td></tr>
                    )}
                  </Fragment>
                ))}
              </tbody>
            </table>
          </div>)}
      </Panel>
    </div>
  );
}
